import { Component, OnInit } from '@angular/core';
import { inductryMaster } from '../../../Models/InductryMasterModel';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AdminInductryMasterServices } from '../../../Services/Admin/InductryMaster';
import { CheckAuth } from '../../../Services/UtilityService';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-manage-industry',
  templateUrl: './manage-industry.component.html',
  styleUrls: ['./manage-industry.component.css']
})
export class ManageIndustryComponent implements OnInit {
  tokenKey: string = '';
  inductryMaster = new inductryMaster();
  statusCode: number = 0;
  insertedIndustryID: number = 0;
  buttonText: string = '';
  updateDeleteID: string = '';

  industryForm = new FormGroup({
    inductryId: new FormControl(''),
    industryName: new FormControl('', Validators.required),
    // isActive: new FormControl('Active', Validators.required),
    isActive: new FormControl('true', Validators.required),
    displayOrder: new FormControl(''),
    totalRecords: new FormControl('')
  });

  constructor(private toastr: ToastrService,private checkAuth: CheckAuth, private industryService: AdminInductryMasterServices, private router: Router, private activedRoute: ActivatedRoute) {
    // this.inductryMaster.isActive = "Active"
    this.inductryMaster.isActive = "true"
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));

  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.buttonText = 'Save';
    this.activedRoute.params.subscribe((params: Params) => {
      this.updateDeleteID = params['id'];
      // Bind Edit Data 
      if (this.updateDeleteID != null) {
        this.getIndustry(this.updateDeleteID);
        this.buttonText = "Update";
      }
    });

  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  saveIndustry(industryForm: NgForm) {
    this.inductryMaster = industryForm.value;
    if(industryForm.value["industryName"] == "" || industryForm.value["industryName"] == undefined || industryForm.value["industryName"] == null)
    {
      this.showMessage('Please enter industry name', 'Error', 'error');
      return;
    }

    debugger;
    if (this.inductryMaster != null) {
      if (parseInt(this.inductryMaster.inductryId) > 0) {
        this.industryService.AddUpdateInductryMaster(this.tokenKey, industryForm.value["industryName"], industryForm.value["isActive"], this.updateDeleteID)
          .subscribe(industryId => {
            debugger;
            this.insertedIndustryID == industryId["industryId"]
            this.setOprationSession('Edited');
            this.router.navigate(['/admin/industry']);
          },
            error => this.statusCode = error);
      }
      else {
        this.industryService.AddUpdateInductryMaster(this.tokenKey, industryForm.value["industryName"], industryForm.value["isActive"], 'null')
          .subscribe(industryId => {
            debugger;
            this.insertedIndustryID == industryId["industryId"]
            this.setOprationSession('Added');
            this.router.navigate(['/admin/industry']);
          },
            error => this.statusCode = error);
      }
    }
  }

  setOprationSession(AddEdit: string) {    
      sessionStorage.setItem('IndustryCRUDStatus', AddEdit);
  }
  getIndustry(inductryId: string) {
    debugger;
    if (inductryId != null) {
      this.industryService.getIndustry(this.tokenKey, inductryId)
        .subscribe(data => {
          debugger;
          this.inductryMaster = data["inductryMaster"][0];
          this.industryForm.setValue({
            'industryName': this.inductryMaster.inductryName,
            'inductryId': this.inductryMaster.inductryId,
            //'isActive': this.inductryMaster.isActive ? 'Active' : 'Deactive',            
            'isActive': this.inductryMaster.isActive,            
            'displayOrder': this.inductryMaster.displayOrder,
            'totalRecords': this.inductryMaster.totalRecords
          });
          // if (this.inductryMaster.isActive) {
          //   this.inductryMaster.isActive = 'Active';
          // }
          // else {
          //   this.inductryMaster.isActive = 'Deactive';
          // }
          // console.log(data["inductryMaster"][0]);
        },
          error => this.statusCode = error);
    }
  }

  returnToIndustryList() {
    this.router.navigate(['/admin/industry']);
  }

}
